import { useState } from "react";

export const UseAlert = (mapAlertSuccess = {}) => {
    const [alertText, setAlertText] = useState("");
    const [severity, setSeverity] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [action, setAction] = useState(null);

    const [openDialog, setOpenDialog] = useState(false);
    const [dialogContentText, setDialogContentText] = useState("");
    const [dialogAction, setDialogAction] = useState(null);

    const confirmAction = (actionName, callback, content) => {
        setAction(actionName);
        setDialogContentText(content);
        setDialogAction(() => callback);
        setOpenDialog(true);
    };

    const handleShowAlert = (variant, msg) => {
        setSeverity(variant);
        setAlertText(msg);
        setShowAlert(true);
        setTimeout(() => {
            setShowAlert(false);
            setSeverity("");
            setAlertText("");
        }, 2000);
    };

    const executeAction = async () => {
        if (dialogAction) {
            try {
                await dialogAction();
                handleShowAlert(
                    "success",
                    mapAlertSuccess[action] || "Solicitud realizada con éxito."
                );
            } catch {
                handleShowAlert("error", "Ocurrió un error, intente nuevamente!");
            }
        }
        setOpenDialog(false);
    };

    return {
        alertText,
        severity,
        showAlert,
        openDialog,
        dialogContentText,
        action,
        setAlertText,
        setSeverity,
        setShowAlert,
        confirmAction,
        executeAction,
        setOpenDialog,
        handleShowAlert,
    };
};
